import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ShieldCheck, Zap } from 'lucide-react';
const HOTMART_URL = 'https://go.hotmart.com/I104349537S?dp=1';
export function FinalCTA() {
  return <section id="final-cta" className="py-24 px-4 bg-[#5A7D60] text-white relative overflow-hidden" data-id="element-65">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-66">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-67">
          <pattern id="leaf-pattern-cta" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-68">
            <path d="M20 0C15 5 15 15 20 20C25 15 25 5 20 0Z" fill="currentColor" data-id="element-69" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#leaf-pattern-cta)" data-id="element-70" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-72">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mb-8 leading-tight" data-id="element-73">
            Hoy puede ser el primer día de una crianza más tranquila
          </h2>

          <p className="text-xl text-white/90 max-w-2xl mx-auto mb-12 font-light leading-relaxed" data-id="element-74">
            No tienes que seguir adivinando. Tienes a tu alcance las
            herramientas para acompañar a tus hijos con respeto, seguridad y
            amor. Tu familia se lo merece.
          </p>

          <div className="flex flex-col items-center gap-6" data-id="element-75">
            <motion.a href={HOTMART_URL} target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center justify-center rounded-full font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5A7D60] bg-white text-[#5A7D60] hover:bg-white/90 shadow-xl w-full sm:w-auto text-lg px-10 h-16" data-id="element-76">
              Sí, quiero acceder al Pack Completo ahora
            </motion.a>

            <div className="flex flex-wrap justify-center gap-4 text-sm text-white/80 mt-4" data-id="element-77">
              <span className="flex items-center gap-1.5" data-id="element-78">
                <Zap size={14} data-id="element-79" /> Acceso inmediato
              </span>
              <span className="hidden sm:inline" data-id="element-80">·</span>
              <span className="flex items-center gap-1.5" data-id="element-81">
                <ShieldCheck size={14} data-id="element-82" /> Garantía de 30 días
              </span>
              <span className="hidden sm:inline" data-id="element-83">·</span>
              <span className="flex items-center gap-1.5" data-id="element-84">
                <Lock size={14} data-id="element-85" /> Pago seguro
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}